import React from "react";

function DateFormatter({ dateString }) {
  const date = new Date(dateString);

  // const month = months[date.getMonth()];
  const month = date.getMonth();
  const day = date.getDate();
  const year = date.getFullYear();

  const padZero = (num) => num.toString().padStart(2, "0");

  const formattedMonth = padZero(month);
  const formattedDay = padZero(day);

  const formattedDate = ` ${year}/${formattedMonth}/${formattedDay}`;

  return <span>{formattedDate}</span>;
}

export default DateFormatter;